export default "__VITE_ASSET__Dyo1Idi4__"